<template>
    <div class="activity" ref="BigMain" @scroll="scrollEvent">
        <navigation-bar Back Bell :name="name"/>
        <div class="tabs" v-if="newsOn||storeOn||mapOn">
            <div @click="toSlide(tab[0])" :class="{active : tabNum===tab[0]}">
                首頁
            </div>
            <div v-if="newsOn" @click="toSlide(tab[1])" :class="{active : tabNum===tab[1]}">
                活動公告
            </div>
            <div v-if="storeOn" @click="toSlide(tab[2])" :class="{active : tabNum===tab[2]}">
                參與店家
            </div>
            <div v-if="mapOn" @click="toSlide(tab[3])" :class="{active : tabNum===tab[3]}">
                友善地圖
            </div>
            <!--<router-link :to="{ name: 'Coupon', query:{id: id}}" v-bind:class="{'active': $route.name ==='Coupon'}">
                優惠領取
            </router-link>
            <router-link :to="{ name: 'Traffic', query:{id: id}}"
                         v-bind:class="{'active': $route.name ==='Traffic'}">
                交通資訊
            </router-link>
            <router-link :to="{ name: 'RecommendCode', query:{id: id}}"
                         v-bind:class="{'active': $route.name ==='RecommendCode'}">
                My推薦碼
            </router-link>-->
        </div>

        <div class="main">
            <swiper ref="mySwiper" :options="swiperOptions">
                <swiper-slide>
                    <div class="swipe-content" ref="home">
                        <router-view class="swipe-con"/>
                    </div>
                </swiper-slide>
                <swiper-slide v-show="newsOn">
                    <div class="swipe-content" ref="news">
                        <router-view name="news" class="swipe-con" v-if="LoadingNum[tab[1]]===1"/>
                    </div>
                </swiper-slide>
                <swiper-slide v-show="storeOn">
                    <div class="swipe-content" ref="store">
                        <router-view name="store" class="swipe-con" v-if="LoadingNum[tab[2]]===1"/>
                    </div>
                </swiper-slide>
                <swiper-slide v-show="mapOn">
                    <div class="swipe-content" ref="map">
                        <router-view name="map" class="swipe-con" v-if="LoadingNum[tab[3]]===1"/>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    import {notNull} from "@/util/common";
    let vm = null;
    export default {
        name: 'ActivityIndex',
        components: {
            Swiper,
            SwiperSlide,
        },
        data() {
            return {
                id: this.$route.query.id,
                //有無活動公告
                newsOn:false,
                //有無參與店家
                storeOn:false,
                //有無友善地圖
                mapOn:false,
                //主題活動標題
                name: '',
                //目前索引值
                tabNum: 0,
                //頁籤索引值 [首頁,活動公告,參與店家,友善地圖]
                tab:[0,'','',''],
                //捲動紀錄定位
                scroll: [0,0,0,0],
                //判斷是否初次載入 0=初次載入，1=已載入
                LoadingNum:[],
                //swiper套件設定
                swiperOptions: {
                    on: {
                        slideChange(){
                            // 这里有坑，需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
                            const index = this.activeIndex
                            vm.tabNumber(index);
                        },
                    },
                    breakpoints: {
                        //電腦版不給左右滑動
                        1024: {
                            noSwipingSelector: '.swiper-slide',
                            //autoHeight: true,
                            slideSpeed: 0,
                            speed: 0,
                        }
                    },
                },
            }
        },
        created() {
            this.setupData();
            vm = this;
        },
        mounted () {
            //滚动事件记录位置
            this.$refs.news.addEventListener("scroll", () => {
                this.scroll[1] = this.$refs.news.scrollTop;
            });
            this.$refs.store.addEventListener("scroll", () => {
                this.scroll[2] = this.$refs.store.scrollTop;
            });
        },
        activated(){
            const fullWidth = window.innerWidth;
            if(fullWidth>=1024){
                //網頁版紀錄捲動位置
                this.$refs.BigMain.scrollTop = this.scroll[0];
            }else{
                //手機版紀錄捲動位置
                this.$refs.news.scrollTop = this.scroll[1]
                this.$refs.store.scrollTop = this.scroll[2]
            }
        },
        methods: {
            setupData() {
                this.$http.fetch`OinActivityTabCheck${{
                    'id':parseInt(this.id),
                }}${json=>{
                    if (notNull(json.data)) {
                        this.newsOn = json.data.announcementCount>0?true:false;
                        this.mapOn = json.data.mapImage != ''?true:false;
                        this.storeOn = json.data.storeCount>0?true:false;
                        //因為swiper區塊是動態的，tab索引值要加下面判斷
                        if(this.newsOn){
                            //有參與店家時索引值為[0,1,2,3]，反之為[0,1,'',2]
                            this.tab = this.storeOn?[0,1,2,3]:[0,1,'',2]
                            //判斷是否初次載入陣列
                            this.LoadingNum = this.storeOn?[0,0,0,0]:[0,0,0]
                        }
                        else{
                            //有參與店家時索引值為[0,'',1,2]，反之為[0,'','',1]
                            this.tab = this.storeOn?[0,'',1,2]:[0,'','',1]
                            //判斷是否初次載入陣列
                            this.LoadingNum = this.storeOn?[0,0,0]:[0,0]
                        }

                    }
                }}`;
                this.$http.fetch`GetOinActivityInfo${{
                    'id': parseInt(this.id),
                }}
                ${json => {
                    this.name = json.name;
                }}`;
            },
            toSlide(index) {
                this.$refs.mySwiper.$swiper.slideTo(index)
            },
            tabNumber(index) {
                this.tabNum = index;
                this.LoadingNum[index] = 1;
            },
            //捲動紀錄位置
            scrollEvent() {
                const fullWidth = window.innerWidth;
                if(fullWidth>=1024){
                    //網頁版紀錄捲動位置
                    this.scroll[0] = this.$refs.BigMain.scrollTop;
                }
            },
        },
    }
</script>

<style lang="less" scoped src="../../less/activity.less"/>
